<template>
    <div class="card-body row py-4">
        <div class="col-sm-4" style="align-self: center;">
            <h4>Reviews History</h4>
        </div>
        <div class="col-sm-8">
            <v-row>
                <v-col md="9">
                </v-col>
                <v-col md="3">
                    <v-select
                        v-model="filters.appraisalName"
                        :items="availableAppraisalNames"
                        :menu-props="{ maxHeight: '400' }"
                        label="Select"
                        solo
                        dense
                        hint="Select appraisal"
                        persistent-hint
                    ></v-select>
                </v-col>
            </v-row>
        </div>
        <div class="col-sm-12 py-0">
            <div class="main-content mt-0 px-0 py-0">
                <div>
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th class="text-left" scope="col">
                                        Appraisal Name
                                    </th>
                                    <th class="text-left" scope="col">
                                        Duration
                                    </th>
                                    <th class="text-left" scope="col">
                                        Final Score
                                    </th>
                                    <th class="text-left" scope="col">
                                        Rating
                                    </th>
                                    <th class="text-center" scope="col">
                                        Reviews History
                                    </th>
                                    <th class="text-center" scope="col">
                                        Feedback History
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(EA, index) in filteredAllEmployeeReviewers" :key="'employee-appraisal-'+index">
                                    <td class="text-left">{{ EA.appraisal_name }}</td>
                                    <td v-if="getAppraisalById(EA.appraisal_id)" class="text-left">
                                        {{ 
                                            new Date(getAppraisalById(EA.appraisal_id).start_date)
                                            .toUTCString()
                                            .substring(0, 16) 
                                            + ' - ' +
                                            new Date(getAppraisalById(EA.appraisal_id).end_date)
                                            .toUTCString()
                                            .substring(0, 16) 
                                        }}
                                    </td>
                                    <td v-else class="text-left">
                                        <i>No duration specified</i>
                                    </td>
                                    <td class="text-left">
                                        {{ getEmployeeFinalScore(validEmployeeId, EA.appraisal_id) }}
                                    </td>
                                    <td class="text-left">
                                        {{ getEmployeeFinalRating(validEmployeeId, EA.appraisal_id) }}
                                    </td>
                                    <td v-if="(getAppraisalById(EA.appraisal_id) ? getAppraisalById(EA.appraisal_id).multi_rater == 1 : false)" class="text-center">
                                        <button v-if="EA.final_rating && EA.total_score" @click="(current_appraisal_id = EA.appraisal_id, current_employee_id = EA.employee_id, view_reviews_dialog = true)" type="button" class="btn btn-secondary btn-sm ripple">
                                            View History
                                        </button>
                                        <div v-else>
                                            <i>Appraisal is unpublished</i>
                                        </div>
                                    </td>
                                    <td v-else class="text-center">
                                        <div>
                                            <i>Multi-rater disabled for this appraisal</i>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <button v-if="EA.final_rating && EA.total_score" @click="(current_appraisal_id = EA.appraisal_id, current_employee_appraisal_id = EA.id, current_employee_id = validEmployeeId, view_appraisal_feedbacks_dialog = true)" type="button" class="btn btn-secondary btn-sm ripple">
                                            View Feedback
                                        </button>
                                        <div v-else>
                                            <i>Appraisal is unpublished</i>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>


        <!-- Dialog for viewing reviews -->
        <v-dialog v-model="view_reviews_dialog" max-width="900px">
            <v-card>
                <v-card-title class="text-left d-block">
                    <span class="headline">Reviews {{ getAppraisalById(current_appraisal_id) ? `[${getAppraisalById(current_appraisal_id).appraisal_name}]` : '' }}</span>
                    <span  class="headline float-right">
                        <button @click="triggerPrint()" style="float: right;" type="button"
                        class="btn btn-sm btn-secondary m-1 text-white btn-raised ripple">
                            Print
                        </button>
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th class="text-left" scope="col">
                                        Reviewer Name
                                    </th>
                                    <th class="text-left" scope="col">
                                        Appraisal Name
                                    </th>
                                    <th class="text-left" scope="col">
                                        Appraisal Duration
                                    </th>
                                    <th class="text-left" scope="col">
                                        Final Score
                                    </th>
                                    <th class="text-left" scope="col">
                                        Rating
                                    </th>
                                    <th class="text-left" scope="col">
                                        Print Breakdown
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-left" v-if="singleEmployeeObject(current_employee_id)">
                                        {{ singleEmployeeObject(current_employee_id).employee_fristname + ' ' + singleEmployeeObject(current_employee_id).employee_lastname }}
                                    </td>
                                    <td v-if="getAppraisalById(current_appraisal_id)" class="text-left">
                                        {{ getAppraisalById(current_appraisal_id).appraisal_name }}
                                    </td>
                                    <td v-else class="text-left">
                                        <i>Appraisal not found</i>
                                    </td>
                                    <td v-if="getAppraisalById(current_appraisal_id)" class="text-left">
                                        {{ 
                                            new Date(getAppraisalById(current_appraisal_id).start_date)
                                            .toUTCString()
                                            .substring(0, 16) 
                                            + ' - ' +
                                            new Date(getAppraisalById(current_appraisal_id).end_date)
                                            .toUTCString()
                                            .substring(0, 16) 
                                        }}
                                    </td>
                                    <td v-else class="text-left">
                                        <i>No duration specified</i>
                                    </td>
                                    <td class="text-left">
                                        {{ getReviewerFinalScore(current_employee_id, current_employee_id, current_appraisal_id) }}
                                    </td>
                                    <td class="text-left">
                                        {{ getReviewerFinalRating(current_employee_id, current_employee_id, current_appraisal_id) }}
                                    </td>
                                    <td class="text-left">
                                        <i @click="printAppraisalReview(current_appraisal_id, current_employee_id, current_employee_id)" class="fal fa-print fa-2x cursor-pointer style='color: #069;'"></i>
                                    </td>
                                </tr>
                                <tr v-for="(reviewer, index) in getEmployeeReviewers(current_appraisal_id, current_employee_id)" :key="'reviewer' + index">
                                    <td class="text-left">
                                        {{ reviewer.employee_fristname + ' ' + reviewer.employee_lastname }}
                                    </td>
                                    <td v-if="getAppraisalById(current_appraisal_id)" class="text-left">
                                        {{ getAppraisalById(current_appraisal_id).appraisal_name }}
                                    </td>
                                    <td v-else class="text-left">
                                        <i>Appraisal not found</i>
                                    </td>
                                    <td v-if="getAppraisalById(current_appraisal_id)" class="text-left">
                                        {{ 
                                            new Date(getAppraisalById(current_appraisal_id).start_date)
                                            .toUTCString()
                                            .substring(0, 16) 
                                            + ' - ' +
                                            new Date(getAppraisalById(current_appraisal_id).end_date)
                                            .toUTCString()
                                            .substring(0, 16) 
                                        }}
                                    </td>
                                    <td v-else class="text-left">
                                        <i>No duration specified</i>
                                    </td>
                                    <td class="text-left">
                                        {{ getReviewerFinalScore(current_employee_id, reviewer.reviewer_id, current_appraisal_id) }}
                                    </td>
                                    <td class="text-left">
                                        {{ getReviewerFinalRating(current_employee_id, reviewer.reviewer_id, current_appraisal_id) }}
                                    </td>
                                    <td class="text-left">
                                        <i @click="printAppraisalReview(current_appraisal_id, current_employee_id, reviewer.reviewer_id)" class="fal fa-print fa-2x cursor-pointer style='color: #069;'"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="view_reviews_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog for viewing reviews -->

        <!-- Dialog for viewing appraisal feedback -->
        <v-dialog v-model="view_appraisal_feedbacks_dialog" max-width="1200px">
            <v-card>
                <v-card-title class="d-block">
                    <span class="headline">All Feedbacks</span>
                    <span v-if="employeeAppraisalIsEnded(current_employee_appraisal_id) === false" class="headline float-right">
                        <button @click="add_appraisal_feedback_dialog = true" style="float: right;" type="button"
                        class="btn btn-sm btn-secondary m-1 text-white btn-raised ripple">
                            Add Feedback
                        </button>
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <div class="card-body row py-4">
                            <div class="col-sm-12 py-0">
                                <div class="main-content mt-0 px-0 py-0">
                                    <div>
                                        <div class="table-responsive">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" scope="col">
                                                            Initial Commenter
                                                        </th>
                                                        <th class="text-left" scope="col">
                                                            Feedback Type
                                                        </th>
                                                        <th class="text-left" scope="col">
                                                            Comment
                                                        </th>
                                                        <th class="text-left" scope="col">
                                                            Response
                                                        </th>
                                                        <th v-if="employeeAppraisalIsEnded(current_employee_appraisal_id) === false" class="text-center" scope="col">
                                                            Add Response
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="feedback in getFeedbacksByAppraisalId(current_employee_id, current_appraisal_id)" :key="feedback.id">
                                                        <td class="text-left">
                                                            {{
                                                                singleEmployeeObject(feedback.employee_id)
                                                                ?
                                                                (
                                                                    singleEmployeeObject(feedback.employee_id).employee_fristname
                                                                    + ' ' +
                                                                    singleEmployeeObject(feedback.employee_id).employee_lastname
                                                                    )
                                                                    :
                                                                    'Employee not found'
                                                                }}
                                                        </td>
                                                        
                                                        <td v-if="feedback.feedback_type == 1" class="text-left">Satisfied</td>
                                                        <td v-else-if="feedback.feedback_type == 2" class="text-left">Not Satisfied</td>
                                                        <td v-else class="text-left">Neutral</td>

                                                        <td v-if="feedback.comment" class="text-left">{{ feedback.comment }} {{ 
                                                            '('
                                                            +
                                                            new Date(feedback.created_at).toDateString() 
                                                            + 
                                                            ' ' 
                                                            + 
                                                            new Date(feedback.created_at).toLocaleTimeString()
                                                            +
                                                            ')' }}
                                                        </td>
                                                        <td v-else class="text-left">
                                                            <i>No comment added</i>
                                                        </td>

                                                        <td v-if="getFeedbackResponses(feedback.feedbackcomment_id).length >= 1" class="text-left">
                                                            <ul>
                                                                <li 
                                                                v-for='(response, index) in getFeedbackResponses(feedback.feedbackcomment_id)'
                                                                :key='`response-`+index'
                                                                >
                                                                    {{
                                                                        response.response
                                                                        +
                                                                        ' ('
                                                                        +
                                                                        new Date(response.updated_at).toDateString() 
                                                                        + 
                                                                        ' ' 
                                                                        + 
                                                                        new Date(response.updated_at).toLocaleTimeString()
                                                                        +
                                                                        ')'
                                                                    }}
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td v-else class="text-left">
                                                            <i>No response added</i>
                                                        </td>
                                                        
                                                        
                                                        <td v-if="employeeAppraisalIsEnded(current_employee_appraisal_id) === false" class="text-center">
                                                            <i @click="launchEditResponse(feedback.feedbackcomment_id)" class="fas fa-reply cursor-pointer"></i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="view_appraisal_feedbacks_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog for viewing appraisal feedback -->

        <!-- Dialog for adding appraisal feedback -->
        <v-dialog v-model="add_appraisal_feedback_dialog" max-width="600px">
            <v-card>
                <v-card-title class="d-block">
                    <span class="headline">Add Appraisal Feedback</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <div class="container-fluid">
                            <v-row>
                                <v-col cols="12" >
                                    <span style="color: #111d5e;">Feedback Type <i class="fal fa-asterisk" style="font-size: 8px; color: #f00; position: relative; bottom: 5px;"></i></span>
                                    <v-select 
                                        v-model="appraisal_feedback_form.feedback_type" 
                                        placeholder="Feedback type"
                                        solo 
                                        class="mt-2" 
                                        :items="['Satisfied', 'Not Satisfied', 'Neutral']" 
                                        dense 
                                        :full-width="true"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" >
                                    <span style="color: #111d5e;">Comment</span>
                                    <v-textarea v-model="appraisal_feedback_form.comment" placeholder="Enter comment" solo class="mt-2"></v-textarea>
                                </v-col>
                                <v-col cols="12" class="text-center">
                                    <button
                                        @click="appraisal_feedback_form.button_loading ? null : submit_appraisal_feedback()"
                                        type="button"
                                        class="btn btn-secondary m-1 ripple w-25 px-0"
                                    >
                                        {{ appraisal_feedback_form.button_text }}
                                        <v-icon
                                            :style="!appraisal_feedback_form.button_loading ? 'display: none;' : 'color: #fff; padding: 0px 10px; font-size: 16px;'"
                                        >
                                            fal fa-circle-notch fa-spin
                                        </v-icon>
                                    </button>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="add_appraisal_feedback_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog for adding appraisal feedback -->

        <!-- Dialog for adding feedback response -->
        <v-dialog v-model="add_feedback_response_dialog" max-width="600px">
            <v-card>
                <v-card-title class="d-block">
                    <span class="headline">Add Feedback Response</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <div class="container-fluid">
                            <v-row>
                                <v-col cols="12" >
                                    <span style="color: #111d5e;">Comment</span>
                                    <v-textarea v-model="feedback_response_form.comment" placeholder="Enter comment" solo class="mt-2"></v-textarea>
                                </v-col>
                                <v-col cols="12" class="text-center">
                                    <button
                                        @click="feedback_response_form.button_loading ? null : submit_feedback_response()"
                                        type="button"
                                        class="btn btn-secondary m-1 ripple w-25 px-0"
                                    >
                                        {{ feedback_response_form.button_text }}
                                        <v-icon
                                            :style="!feedback_response_form.button_loading ? 'display: none;' : 'color: #fff; padding: 0px 10px; font-size: 16px;'"
                                        >
                                            fal fa-circle-notch fa-spin
                                        </v-icon>
                                    </button>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="add_feedback_response_dialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog for adding feedback response -->

        <!-- PDF document for printing all reviews -->
        <div id="print" class="d-none d-print-block">
            <v-row class="py-2 px-2" v-if="singleEmployeeObject(current_employee_id)">
                <v-col cols="8">
                    <v-row>
                        <v-col class="text-center pr-0" cols="3">
                            <img style="border-radius: 100%;" class="w-75"
                            :src="
                                singleEmployeeObject(current_employee_id)
                                ?
                                    (
                                        singleEmployeeObject(current_employee_id).profile_image_url 
                                        ? 
                                        (assets_url + singleEmployeeObject(current_employee_id).profile_image_url) 
                                        : 
                                        '/assets/images/default_profile_img.png'
                                    )
                                :
                                '/assets/images/default_profile_img.png'
                            "
                            alt="" />
                        </v-col>
                        <v-col class="pl-0" cols="8">
                            <h4 class="mt-4">{{ singleEmployeeObject(current_employee_id).employee_fristname + ' ' + singleEmployeeObject(current_employee_id).employee_lastname }}</h4>
                            <p class="mb-0 mt-3">
                            {{
                                singleEmployeeObject(current_employee_id).employee_designation ? singleEmployeeObject(current_employee_id).employee_designation : 'No designation specified'
                            }} - {{ singleEmployeeObject(current_employee_id).department_id ? get_dept_name(singleEmployeeObject(current_employee_id).department_id) : 'No assigned department' }}</p>
                            <p>
                                <a :href="'mail:' + singleEmployeeObject(current_employee_id).employee_email" target="_blank">
                                    {{ singleEmployeeObject(current_employee_id).employee_email }}
                                </a>
                            </p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="4">
                    <h3 class="headline text-right">
                        Reviews {{ getAppraisalById(current_appraisal_id) ? `[${getAppraisalById(current_appraisal_id).appraisal_name}]` : '' }}
                    </h3>
                </v-col>
            </v-row>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="text-left" scope="col">
                            Reviewer Name
                        </th>
                        <th class="text-left" scope="col">
                            Appraisal Name
                        </th>
                        <th class="text-left" scope="col">
                            Appraisal Duration
                        </th>
                        <th class="text-left" scope="col">
                            Final Score
                        </th>
                        <th class="text-left" scope="col">
                            Rating
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-left" v-if="singleEmployeeObject(current_employee_id)">
                            {{ singleEmployeeObject(current_employee_id).employee_fristname + ' ' + singleEmployeeObject(current_employee_id).employee_lastname }}
                        </td>
                        <td class="text-left" v-else>
                            <i>Employee not found</i>
                        </td>
                        <td v-if="getAppraisalById(current_appraisal_id)" class="text-left">
                            {{ getAppraisalById(current_appraisal_id).appraisal_name }}
                        </td>
                        <td v-else class="text-left">
                            <i>Appraisal not found</i>
                        </td>
                        <td v-if="getAppraisalById(current_appraisal_id)" class="text-left">
                            {{ 
                                new Date(getAppraisalById(current_appraisal_id).start_date)
                                .toUTCString()
                                .substring(0, 16) 
                                + ' - ' +
                                new Date(getAppraisalById(current_appraisal_id).end_date)
                                .toUTCString()
                                .substring(0, 16) 
                            }}
                        </td>
                        <td v-else class="text-left">
                            <i>No duration specified</i>
                        </td>
                        <td class="text-left">
                            {{ getReviewerFinalScore(current_employee_id, authEmployeeDataForCompany.id, current_appraisal_id) }}
                        </td>
                        <td class="text-left">
                            {{ getReviewerFinalRating(current_employee_id, authEmployeeDataForCompany.id, current_appraisal_id) }}
                        </td>
                    </tr>
                    <tr v-for="(reviewer, index) in getEmployeeReviewers(current_appraisal_id, current_employee_id)" :key="'reviewer' + index">
                        <td class="text-left">
                            {{ reviewer.employee_fristname + ' ' + reviewer.employee_lastname }}
                        </td>
                        <td v-if="getAppraisalById(current_appraisal_id)" class="text-left">
                            {{ getAppraisalById(current_appraisal_id).appraisal_name }}
                        </td>
                        <td v-else class="text-left">
                            <i>Appraisal not found</i>
                        </td>
                        <td v-if="getAppraisalById(current_appraisal_id)" class="text-left">
                            {{ 
                                new Date(getAppraisalById(current_appraisal_id).start_date)
                                .toUTCString()
                                .substring(0, 16) 
                                + ' - ' +
                                new Date(getAppraisalById(current_appraisal_id).end_date)
                                .toUTCString()
                                .substring(0, 16) 
                            }}
                        </td>
                        <td v-else class="text-left">
                            <i>No duration specified</i>
                        </td>
                        <td class="text-left">
                            {{ getReviewerFinalScore(validEmployeeId, reviewer.reviewer_id, current_appraisal_id) }}
                        </td>
                        <td class="text-left">
                            {{ getReviewerFinalRating(validEmployeeId, reviewer.reviewer_id, current_appraisal_id) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- PDF document for printing all reviews -->
        
        <!-- PDF document for printing all review information -->
        <div id="printBreakdown" class="d-none d-print-block">
            <v-row class="py-2 px-2" v-if="singleEmployeeObject(current_employee_id)">
                <v-col cols="8">
                    <v-row>
                        <v-col class="text-center pr-0" cols="3">
                            <img style="border-radius: 100%;" class="w-75"
                            :src="
                                singleEmployeeObject(current_employee_id)
                                ?
                                    (
                                        singleEmployeeObject(current_employee_id).profile_image_url 
                                        ? 
                                        (assets_url + singleEmployeeObject(current_employee_id).profile_image_url) 
                                        : 
                                        '/assets/images/default_profile_img.png'
                                    )
                                :
                                '/assets/images/default_profile_img.png'
                            "
                            alt="" />
                        </v-col>
                        <v-col class="pl-0" cols="8">
                            <h4 class="mt-2">{{ singleEmployeeObject(current_employee_id).employee_fristname + ' ' + singleEmployeeObject(current_employee_id).employee_lastname }}</h4>
                            <p class="mb-0 mt-3">
                            {{
                                singleEmployeeObject(current_employee_id).employee_designation ? singleEmployeeObject(current_employee_id).employee_designation : 'No designation specified'
                            }} - {{ singleEmployeeObject(current_employee_id).department_id ? get_dept_name(singleEmployeeObject(current_employee_id).department_id) : 'No assigned department' }}</p>
                            <p>
                                <a :href="'mail:' + singleEmployeeObject(current_employee_id).employee_email" target="_blank">
                                    {{ singleEmployeeObject(current_employee_id).employee_email }}
                                </a>
                            </p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="4">
                    <h3 class="headline text-right">
                        Review {{ getAppraisalById(current_appraisal_id) ? `[${getAppraisalById(current_appraisal_id).appraisal_name}]` : '' }}
                    </h3>
                    <p v-if="singleEmployeeObject(current_reviewer_id)" class="text-right">Reviewer: <span style="font-weight: bold;">{{ singleEmployeeObject(current_reviewer_id).employee_fristname + ' ' + singleEmployeeObject(current_reviewer_id).employee_lastname }}</span></p>
                </v-col>
            </v-row>
            <v-row class="pt-3">
                <v-col cols="12">
                    <div class="container-fluid">
                        <v-row>
                            <v-col cols="12" class="remove-hint pb-0">
                                <h4 style="color: #111d5e;">Self Appraisal </h4>
                            </v-col>
                            <v-col v-for="(questionnaire, index) in selfAppraisalQuestionnaires" :key="'questionnaire-to-reply'+index" cols="12" >
                                <span style="color: #111d5e;"><span style="font-weight: bold;">Question #{{index+1}}: </span>{{ questionnaire.question }}</span>
                                <v-row>
                                    <v-col cols="12">
                                        <p class="mt-2">
                                            <span style="color: #111d5e; font-weight: bold;">Response: </span>
                                            <span v-if="questionnaire.response">
                                                {{ questionnaire.response }}
                                            </span>
                                            <span v-else>
                                                <i>No response added</i>
                                            </span>
                                        </p>
                                    </v-col>
                                </v-row>
                                
                            </v-col>
                            <v-col cols="12" >
                                <div class="mt-2">
                                    <span style="color: #111d5e; font-weight: bold;">Rating: </span>
                                    <img 
                                    v-for="n in parseInt(selfAppraisalRating)" 
                                    :key="n"
                                    src="/img/star-filled.svg" 
                                    style="
                                        height: 20px;
                                    " 
                                    class="mr-1">
                                    <img 
                                    v-for="n in (5-parseInt(selfAppraisalRating))" :key="n+'_'"
                                    src="/img/star.svg" 
                                    style="
                                        height: 20px;
                                    " 
                                    class="mr-1">
                                </div>
                            </v-col>
                            <v-col cols="12" >
                                <p class="mt-2">
                                    <span style="color: #111d5e; font-weight: bold;">Comment: </span>
                                    <span v-if="selfAppraisalComment">
                                        {{ selfAppraisalComment }}
                                    </span>
                                    <span v-else>
                                        <i>No comment added</i>
                                    </span>
                                </p>
                            </v-col>
                        </v-row>
                        <v-row v-if="employeeGoalsInfo.length >= 1">
                            <v-col cols="12" class="remove-hint pb-0 mt-8">
                                <h4 style="color: #111d5e;">Goals </h4>
                            </v-col>
                            <v-col class="mb-10" cols="6" v-for="(goal, index) in employeeGoalsInfo" :key="'goal-review-'+index">
                                <v-row>
                                    <v-col cols="12" >
                                        <h5 style="color: #111d5e;" class="mb-2">Goal #{{ index + 1 }}: {{ goal.goal_name }}</h5>
                                        <v-row>
                                            <v-col cols="12" class="mb-4">
                                                <div class="ul-widget-s5__progress pr-0">
                                                    <div class="progress">
                                                        <div class="progress-bar bg-secondary" role="progressbar" :style="'width: ' + getGoalCompletionPercentage(goal.goal_id, current_employee_id) + '%'" :aria-valuenow="getGoalCompletionPercentage(goal.goal_id, current_employee_id) " aria-valuemin="0" aria-valuemax="100">{{ getGoalCompletionPercentage(goal.goal_id, current_employee_id)  }}%</div>
                                                    </div>
                                                </div>
                                            </v-col>

                                            <v-col v-if="goal.KRAs.length >= 1" cols="12" class="mb-2">
                                                <v-row v-for="(kra, index) in goal.KRAs" :key="'goal-kra' + index">
                                                    <v-col cols="8">{{ kra.kra }}</v-col>
                                                    <v-col cols="4" class="text-right" style="align-self: center;">
                                                        <span v-if="getEmployeeKRAInfo(kra.id, current_employee_id) && getEmployeeKRAInfo(kra.id, current_employee_id).is_completed == 1" class="badge badge-success text-white">COMPLETED</span>
                                                        <span v-else class="badge badge-warning text-white">INCOMPLETE</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            
                                            <v-col class="remove-msg mb-2" cols="12">
                                                <span>{{ 'Target completion: ' + (goal.achievedtarget || 0) + ' of ' + goal.weightage }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" class="remove-hint mb-2">
                                        <div class="mt-2">
                                            <span style="color: #111d5e; font-weight: bold;">Rating: </span>
                                            <img 
                                            v-for="n in parseInt(goal.rating)" :key="n"
                                            src="/img/star-filled.svg" 
                                            style="height: 20px;" 
                                            class="mr-1">
                                            <img 
                                            v-for="n in (5-parseInt(goal.rating))" :key="n+'_'"
                                            src="/img/star.svg" 
                                            style="height: 20px;" 
                                            class="mr-1">
                                        </div>
                                    </v-col>
                                    <v-col cols="12" class="remove-hint mb-2">
                                        <p class="mt-2">
                                            <span style="color: #111d5e; font-weight: bold;">Comment: </span>
                                            <span v-if="goal.comment">
                                                {{ goal.comment }}
                                            </span>
                                            <span v-else>
                                                <i>No comment added</i>
                                            </span>
                                        </p>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="pt-5">
                            <v-col cols="12">
                                <h5>Overall score for {{ employeeObject(currentEmployeeAppraisal ? currentEmployeeAppraisal.employee_id : validEmployeeId).employee_fristname + ' ' + employeeObject(currentEmployeeAppraisal ? currentEmployeeAppraisal.employee_id : validEmployeeId).employee_lastname }}</h5>
                            </v-col>
                            <v-col cols="12">
                                <div class="main-content mt-0 px-0 py-0">
                                    <div class="table-responsive">
                                        <table class="table mb-2">
                                            <thead>
                                                <tr>
                                                    <th class="text-left" scope="col">
                                                        Module
                                                    </th>
                                                    <th class="text-left" scope="col">
                                                        Score
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="text-left">Appraisal</td>
                                                    <td class="text-left">{{ selfAppraisalRating }} of 5</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-left">Goal</td>
                                                    <td class="text-left">{{ averageGoalScore }} of 5</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-left">Final Score</td>
                                                    <td class="text-left">{{ (parseFloat(selfAppraisalRating) + averageGoalScore) / 2 }} of 5</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
        </div>
        <!-- PDF document for printing all review information -->

    </div>
</template>

<script>
import axios from 'axios';
import { 
    ASSETS_URL, 
    BASE_URL 
} from '@/main';
import { 
    mapActions, 
    mapGetters 
} from 'vuex';
export default {
    props: {
        getTrueEmployeeAppraisals: Function,
        getAppraisalById: Function,
        getEmployeeFinalScore: Function,
        getEmployeeFinalRating: Function,
        singleEmployeeObject: Function,
        get_dept_name: Function,
        getReviewerFinalScore: Function,
        getReviewerFinalRating: Function,
        getEmployeeReviewers: Function,
        getFeedbacksByAppraisalId: Function,
        getEmployeeAppraisalReview: Function,
        getResponseByQuestionId: Function,
        getEmployeeGoalsInfo: Function,
        getEmployeeKRAInfo: Function,
        employeeObject: Function,
        getFeedbackResponses: Function,
        employeeAppraisalIsEnded: Function,
        getGoalCompletionPercentage: Function
    },
    data() {
        return {
            current_appraisal_id: null,
            current_employee_id: null,
            current_employee_appraisal_id: null,
            view_reviews_dialog: false,
            view_appraisal_feedbacks_dialog: false,
            add_appraisal_feedback_dialog: false,
            add_feedback_response_dialog: false,
            appraisal_feedback_form: {
                feedback_type: '',
                comment: '',
                button_loading: false,
                button_text: 'Submit Feedback',
            },
            feedback_response_form: {
                commentId: null,
                comment: '',
                button_loading: false,
                button_text: 'Submit Response',
            },
            current_reviewer_id: null,
            selfAppraisalComment: '',
            selfAppraisalRating: 0,
            currentEmployeeAppraisal: {},
            selfAppraisalQuestionnaires: [],
            employeeGoalsInfo: [],

            filters: {
                appraisalName: ''
            }
        }
    },
    computed: {
        ...mapGetters([
            'authCompanyData',
            'authEmployeeDataForCompany',
            'authCompanyQuestionnaires',
            'validEmployeeId'
        ]),
        assets_url() {
            return ASSETS_URL;
        },
        filteredQuestionnaires() {
            let _this = this, result = [];
            result = _this.authCompanyQuestionnaires.filter(q => q.appraisal_id == _this.current_appraisal_id);
            return result;
        },
        averageGoalScore() {
            let _this = this, value = 0;
            _this.employeeGoalsInfo.forEach(goal => {
                value += parseFloat(goal.rating);
            });
            value = value/_this.employeeGoalsInfo.length;
            return value || 0;
        },
        allEmployeeReviewers() {
            return this.getTrueEmployeeAppraisals(this.validEmployeeId);
        },
        filteredAllEmployeeReviewers() {
            const _this = this;
            
            // Search and filter by appraisal name
            let result = _this.allEmployeeReviewers.filter(EMPLOYEE_REVIEWER => {
                if (_this.filters.appraisalName === 'All') {
                    // If all appraisals should show
                    return true;
                } else {
                    // If filtering by appraisal name
                    return EMPLOYEE_REVIEWER.appraisal_name.indexOf(_this.filters.appraisalName) !== -1;
                }
            });
            // Search and filter by appraisal name

            return result;
        },
        availableAppraisalNames() {
            const _this = this;
            let appraisalNames = ['All'];
            _this.allEmployeeReviewers.forEach(EMPLOYEE_REVIEWER => {
                if (appraisalNames.indexOf(EMPLOYEE_REVIEWER.appraisal_name) === -1) {
                    appraisalNames.splice(appraisalNames.length, 0, EMPLOYEE_REVIEWER.appraisal_name);
                }
            });
            return appraisalNames;
        },
    },
    methods: {
        ...mapActions([
            'fetch_company_appraisal_feedbacks'
        ]),
        triggerPrint() {
            let _this = this;
            setTimeout(() => {
                _this.print();
            }, 1000);
        },
        async print() {
            let _this = this;
            await _this.$htmlToPaper('print', _this.mixinPrintPortraitOptions);
        },
        printAppraisalReview(appraisal_id, validEmployeeId, reviewerId) {
            const _this = this, employeeAppraisals = _this.getTrueEmployeeAppraisals(validEmployeeId);
            let EA = employeeAppraisals.filter(a => a.appraisal_id == appraisal_id);
            if (EA.length >= 1) {
                [EA] = EA;
            } else {
                EA = null;
                return;
            }
            _this.current_reviewer_id = reviewerId;
            _this.selfAppraisalComment = "";
            _this.selfAppraisalRating = 0;
            _this.current_appraisal_id = EA.appraisal_id, 
            _this.currentEmployeeAppraisal = EA;
            let employeeAppraisalReview = _this.getEmployeeAppraisalReview(EA.appraisal_id, EA.employee_id, validEmployeeId);
            if (employeeAppraisalReview) {
                _this.selfAppraisalComment = employeeAppraisalReview.comment;
                _this.selfAppraisalRating = employeeAppraisalReview.rating ? parseInt(employeeAppraisalReview.rating) : 0;
            }
            _this.selfAppraisalQuestionnaires = _this.filteredQuestionnaires.map(FQ => {
                let responseObj = _this.getResponseByQuestionId(FQ.id, EA.employee_id);
                return {
                    questionnaireId: FQ.id,
                    question: FQ.question,
                    response: responseObj ? responseObj.response : '',
                    buttonText: 'Submit',
                    buttonLoading: false
                }
            });
            _this.employeeGoalsInfo = _this.getEmployeeGoalsInfo(_this.current_appraisal_id, EA.employee_id, reviewerId);
            setTimeout(() => {
                _this.printBreakdown();
            }, 1000);
        },
        async printBreakdown() {
            let _this = this;
            await _this.$htmlToPaper('printBreakdown', _this.mixinPrintPortraitOptions);
        },
        launchEditResponse(commentId) {
            this.feedback_response_form.commentId = commentId;
            this.add_feedback_response_dialog = true;
        },
        submit_appraisal_feedback() {
            let _this = this, feedback_type = _this.appraisal_feedback_form.feedback_type.toLowerCase();
            if (feedback_type == 'satisfied') {
                feedback_type = 1;
            } else if (feedback_type == 'not satisfied') {
                feedback_type = 2;
            } else {
                feedback_type = 3;
            }

            const Toast = _this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", _this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", _this.$swal.resumeTimer);
                },
            });
            
            _this.appraisal_feedback_form.button_text = "";
            _this.appraisal_feedback_form.button_loading = true;
            axios
            .post(`${BASE_URL}createappraisalfeedback`, {
                company_id: _this.authCompanyData.id || _this.authEmployeeDataForCompany.company_id, 
                employee_id: _this.validEmployeeId, 
                appraisal_id: _this.current_appraisal_id,
                feedback_type, 
                comment: _this.appraisal_feedback_form.comment, 
            })
            .then(function () {
                _this.fetch_company_appraisal_feedbacks();
                _this.add_appraisal_feedback_dialog = false;
                _this.appraisal_feedback_form.feedback_type = '';
                _this.appraisal_feedback_form.comment = '';
                Toast.fire({
                    icon: "success",
                    title: `Feedback submitted successfully`,
                });
            })
            .catch(function (error) {
                Toast.fire({
                    icon: "error",
                    title: `Feedback couldn't be submitted`,
                });
                console.log(error);
            })
            .then(function () {
                _this.appraisal_feedback_form.button_loading = false;
                _this.appraisal_feedback_form.button_text = "Submit Feedback";
            });
        },
        submit_feedback_response() {
            let _this = this;
            
            const Toast = _this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", _this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", _this.$swal.resumeTimer);
                },
            });

            _this.feedback_response_form.button_text = "";
            _this.feedback_response_form.button_loading = true;
            axios
                .post(`${BASE_URL}createappraisalfeedbackresponse`, {
                    company_id: _this.authCompanyData.id || _this.authEmployeeDataForCompany.company_id, 
                    employee_id: _this.validEmployeeId, 
                    appraisal_id: _this.current_appraisal_id,
                    comment_id: _this.feedback_response_form.commentId, 
                    response: _this.feedback_response_form.comment, 
                })
                .then(function () {
                    _this.fetch_company_appraisal_feedbacks();
                    _this.add_feedback_response_dialog = false;
                    _this.feedback_response_form.comment = '';
                    Toast.fire({
                        icon: "success",
                        title: `Feedback reponse submitted successfully`,
                    });
                })
                .catch(function (error) {
                    Toast.fire({
                        icon: "error",
                        title: `Feedback response couldn't be submitted`,
                    });
                    console.log(error);
                })
                .then(function () {
                    _this.feedback_response_form.button_loading = false;
                    _this.feedback_response_form.button_text = "Submit Response";
                });
        }
    }
}
</script>

<style>

</style>